import { required } from '@/plugins/vuelidate';
import { BillingDetails } from '../../../api/v1';

export type BillingDetailsFormType = {
  name: string;
  address: {
    line1: string;
    line2: string | null;
    city: string;
    region: string | null;
    postalCode: string;
    countryCode: string;
  };
};

export const buildBillingForm = (
  billingDetails: BillingDetails | null,
): BillingDetailsFormType => ({
  name: billingDetails?.name || '',
  address: {
    line1: billingDetails?.address.line1 || '',
    line2: billingDetails?.address.line2 || '',
    city: billingDetails?.address.city || '',
    region: billingDetails?.address.region || '',
    postalCode: billingDetails?.address.postalCode || '',
    countryCode: billingDetails?.address.countryCode || '',
  },
});

export const billingFormValidations = {
  name: { required },
  address: {
    line1: { required },
    line2: {},
    city: { required },
    region: {},
    postalCode: { required },
    countryCode: { required },
  },
};
